import { useCallback, useMemo } from 'react';
import axiosInstance from '../../../config/axio.config';
import TimelineTable from '../timelineTable/timelineTable';

// Daily timeline: each row is a day and expands into that day's entries.
export default function DailyTimeline({ days = [], totals }) {
  const rows = useMemo(() => days.map((d) => ({ ...d, id: d.date })), [days]);

  const loadDetail = useCallback(async (row) => {
    const { data } = await axiosInstance.get('/financeiro/reports/daily-detail', {
      params: { date: row.id },
    });
    return {
      incomes: (data.incomes || []).map((entry) => ({
        id: `i-${entry.id}`,
        primary: entry.clientName,
        secondary: [
          entry.typeDescription,
          entry.totalInstallments > 1 ? `parcela ${entry.installmentNumber}/${entry.totalInstallments}` : null,
          entry.paymentMethod,
        ].filter(Boolean).join(' · '),
        value: entry.amountPaid,
      })),
      expenses: (data.expenses || []).map((entry) => ({
        id: `e-${entry.id}`,
        primary: entry.supplier,
        secondary: [entry.description, entry.costCenterName].filter(Boolean).join(' · '),
        value: entry.amountPaid,
      })),
    };
  }, []);

  return (
    <TimelineTable
      title="Detalhamento diário"
      rows={rows}
      totals={totals}
      periodColumnLabel="Data"
      unitLabel={['dia', 'dias']}
      pageSize={15}
      allowHideEmpty
      loadDetail={loadDetail}
      emptyLabel="Sem movimentação diária no período"
    />
  );
}
